import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import ImageUpload from "./components/ImageUpload";
import ImageUploadSettings from "./components/ImageUploadSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/imageUpload.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'imageUpload',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_IMAGEUPLOAD'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        action: 'http://fish.iwhalecloud.com:8080/ueditor-example/uploadw',
        accept: 'image/*',
        // eslint-disable-next-line no-template-curly-in-string
        download: 'http://fish.iwhalecloud.com:8080/ueditor-example/downLoadFile?docId=${id}',
        fileIdName: 'docId'
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_IMAGEUPLOAD']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: ImageUpload, // 插件渲染组件
    pluginSettingComponent: ImageUploadSettings, // 插件设置项组件
  }
}
